export default function SuccessIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="m21.05 28.25-4.7-4.7q-.5-.5-1.225-.5-.725 0-1.275.55-.55.55-.55 1.275 0 .725.55 1.225l6 6q.5.5 1.175.5t1.175-.5l11.9-11.9q.5-.5.475-1.2-.025-.7-.525-1.25t-1.25-.55q-.75 0-1.3.55ZM24 44.3q-4.3 0-8.025-1.55-3.725-1.55-6.45-4.275Q6.8 35.75 5.25 32.025 3.7 28.3 3.7 24q0-4.25 1.55-7.975Q6.8 12.3 9.525 9.575q2.725-2.725 6.45-4.3Q19.7 3.7 24 3.7q4.25 0 7.975 1.575 3.725 1.575 6.45 4.3Q41.15 12.3 42.725 16q1.575 3.7 1.575 8t-1.575 8.025q-1.575 3.725-4.3 6.45-2.725 2.725-6.45 4.275Q28.25 44.3 24 44.3ZM24 24Zm0 16.9q7.2 0 12.05-4.85Q40.9 31.2 40.9 24q0-7.2-4.85-12.05Q31.2 7.1 24 7.1q-7.2 0-12.05 4.85Q7.1 16.8 7.1 24q0 7.2 4.85 12.05Q16.8 40.9 24 40.9Z"
      />
    </svg>
  );
}
